<template lang="pug">
    .z-multy-select-item(data-isitem="true") 
        .icon(v-bind:class="{'selected': $props.selected}" v-on:click="select")
        .label(v-on:click="selectOne") {{$props.label}}
</template>
<script>
    export default {
        name: 'z-multy-select-item',
        components: {},
        props: {
            value: {
                type: [String, Number, Boolean],
                default: () => ''
            },
            label: {
                type: [String, Number, Boolean],
                default: () => ''
            },
            selected: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {}
        },
        created() {},
        watch: {},
        computed: {},
        methods: {
            selectOne(e) {
                if (this.$parent) {
                    if (this.$props.selected) this.$parent.unselect(this.$props.label, this.$props.value, true);
                    else this.$parent.select(this.$props.label, this.$props.value, true);
                }
                this.$emit('click', e);
            },
            select(e) {
                if (this.$parent) {
                    if (this.$props.selected) this.$parent.unselect(this.$props.label, this.$props.value);
                    else this.$parent.select(this.$props.label, this.$props.value);
                }
                this.$emit('click', e);
            }
        }
    }
</script>
<style lang="sass">
    .z-multy-select-item
        cursor: pointer
        width: 100%
        font-size: 14px
        line-height: 14px
        display: flex
        align-items: flex-start
        justify-content: flex-start
        .icon
            display: block
            position: relative
            width: 17px
            height: 17px
            background: transparent
            border: 2px solid rgba(0, 0, 0, 0.54)
            border-radius: 2px
            overflow: hidden
            margin: 4px 0 4px 10px
            &::after
                content: ''
                position: absolute
                display: block
                width: 5px
                height: 10px
                border: 2px solid transparent
                border-top: 0
                border-left: 0
                transform: rotate(45deg) scale3D(1, 1, 1)
                transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)
                left: 4px
                top: 0
        .icon.selected    
            background: #448aff
            border-color: #448aff
            &::after
                border-color: #fff
        .label
            display: flex
            align-items: center
            justify-content: flex-start
            width: calc(100% - 22px)
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
            padding: 6px 10px 4px 5px
        &:hover, &.active
            background: #BEBEBE
</style>


// WEBPACK FOOTER //
// ZMultySelectItem.vue?4657558a